import _ from 'underscore';

/* eslint-disable no-var */
// Generated by CoffeeScript 1.10.0
var _intersects, lineFindSelection;

_intersects = function(a, b, hPadding, vPadding) {
    if (hPadding == null) {
        hPadding = 0;
    }
    if (vPadding == null) {
        vPadding = 0;
    }
    return (
        a != null &&
        b != null &&
        b.bry + vPadding >= a.tly - vPadding &&
        b.brx + hPadding >= a.tlx - hPadding &&
        b.tlx - hPadding <= a.brx + hPadding &&
        b.tly - vPadding <= a.bry + vPadding
    );
};

lineFindSelection = function(line, selection) {
    var ar,
        brx,
        bry,
        firstWord,
        from,
        isBottomIntersection,
        isLeftIntersection,
        isRightIntersection,
        isTopIntersection,
        lastWord,
        maxX,
        minX,
        previousWord,
        ref,
        selectFromStart,
        selectToEnd,
        selectedWords,
        selections,
        tlx,
        tly,
        to,
        w,
        words;
    selections = [];
    tlx = line.tlx;
    tly = line.tly;
    brx = line.brx;
    bry = line.bry;
    words = line.words;
    isTopIntersection = selection.tly <= tly && tly <= selection.bry;
    isBottomIntersection = selection.tly <= bry && bry <= selection.bry;
    isLeftIntersection = selection.tlx <= tlx && tlx <= selection.brx;
    isRightIntersection = selection.tlx <= brx && brx <= selection.brx;
    selectFromStart = isTopIntersection || isLeftIntersection;
    selectToEnd = isBottomIntersection || isRightIntersection;
    if (selectFromStart && selectToEnd) {
        selectedWords = (function() {
            var i, len, ref, results;
            ref = words.slice(0);
            results = [];
            for (i = 0, len = ref.length; i < len; i++) {
                w = ref[i];
                results.push(w.word);
            }
            return results;
        })();
        ar = [tlx, tly, brx, bry];
        ar.push(selectedWords);
        selections.push(ar);
    } else {
        firstWord = void 0;
        lastWord = void 0;
        ref = (function(currentLine) {
            var endPoint, points, startPoint;
            points = [];
            startPoint = {
                tlx: selection.x1,
                tly: selection.y1,
                brx: selection.x1,
                bry: selection.y1,
            };
            endPoint = {
                tlx: selection.x2,
                tly: selection.y2,
                brx: selection.x2,
                bry: selection.y2,
            };
            if (_intersects(currentLine, startPoint)) {
                points.push(selection.x1);
            }
            if (_intersects(currentLine, endPoint)) {
                points.push(selection.x2);
            }
            return [_.min(points), _.max(points)];
        })(line);
        minX = ref[0];
        maxX = ref[1];
        previousWord = void 0;
        words.forEach(function(currentWord) {
            if (minX >= currentWord.tlx) {
                firstWord = currentWord;
            }
            if (
                maxX <= currentWord.tlx &&
                previousWord != null &&
                maxX >= previousWord.tlx
            ) {
                lastWord = previousWord;
                if (firstWord == null) {
                    firstWord = currentWord;
                }
            }
            return (previousWord = currentWord);
        });
        if (lastWord == null) {
            lastWord = previousWord;
        }
        if (selectFromStart) {
            from = 0;
        } else {
            from = words.indexOf(firstWord);
        }
        if (selectToEnd) {
            to = words.length;
        } else {
            to = words.indexOf(lastWord);
        }
        selectedWords = (function() {
            var i, len, ref1, results;
            ref1 = words.slice(from, +to + 1 || 9e9);
            results = [];
            for (i = 0, len = ref1.length; i < len; i++) {
                w = ref1[i];
                results.push(w.word);
            }
            return results;
        })();
        selections.push(
            selectFromStart
                ? [tlx, tly, firstWord.brx, firstWord.bry, selectedWords]
                : selectToEnd
                ? [firstWord.tlx, firstWord.tly, brx, bry, selectedWords]
                : firstWord != null && lastWord != null
                ? [
                      firstWord.tlx,
                      firstWord.tly,
                      lastWord.brx,
                      lastWord.bry,
                      selectedWords,
                  ]
                : void 0
        );
    }
    return selections;
};

export default function({ words }, selection) {
    selection = _.extend({}, selection, {
        tlx: _.min([selection.x1, selection.x2]),
        tly: _.min([selection.y1, selection.y2]),
        brx: _.max([selection.x1, selection.x2]),
        bry: _.max([selection.y1, selection.y2]),
    });
    if (words) {
        return words.reduce(function(acc, line) {
            // var i, len, ref, results, s;
            if (_intersects(line, selection)) {
                const ref = lineFindSelection(line, selection);
                // results = [];
                for (let i = 0, len = ref.length; i < len; i++) {
                    acc.push(ref[i]);
                }
            }
            return acc;
        }, []);
    }
    return [];
}



// WEBPACK FOOTER //
// ./src/findSelection.js